import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../lib/supabase";
import ShopLinkCatalog from "../components/ShopLinkCatalog";

// Pretty demo items to visualize the store when it's empty.
// Images are public stock placeholders; replace anytime.
const DEMO_ITEMS = [
  {
    id: 9001, name: "Prime Wireless Headphones", description: "40h battery • Bluetooth 5.3 • Noise canceling",
    price: 2499, qty: 5, category: "Audio", demo_image: "https://images.unsplash.com/photo-1518441902110-1f0f1b1f1b1f?w=800&q=80"
  },
  {
    id: 9002, name: "Urban Daypack 22L", description: "Weatherproof • Laptop sleeve • Lightweight",
    price: 1899, qty: 12, category: "Bags", demo_image: "https://images.unsplash.com/photo-1520975994081-4fbe3f0e6c89?w=800&q=80"
  },
  {
    id: 9003, name: "Quartz Smartwatch", description: "Heart rate • Sleep tracking • 7-day battery",
    price: 3299, qty: 9, category: "Wearables", demo_image: "https://images.unsplash.com/photo-1512446816042-444d641267bc?w=800&q=80"
  },
  {
    id: 9004, name: "Aero Sport Sneakers", description: "Breathable mesh • Cushioned sole",
    price: 2199, qty: 20, category: "Shoes", demo_image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800&q=80"
  },
  {
    id: 9005, name: "Minimalist Desk Lamp", description: "Adjustable arm • Warm/white modes",
    price: 1299, qty: 15, category: "Home", demo_image: "https://images.unsplash.com/photo-1507473885765-e6ed57b89569?w=800&q=80"
  },
  {
    id: 9006, name: "Ceramic Mug Set (4)", description: "Dishwasher safe • Matte finish",
    price: 799, qty: 30, category: "Kitchen", demo_image: "https://images.unsplash.com/photo-1541167760496-1628856ab772?w=800&q=80"
  },
];

export default function StorePage() {
  const { slug } = useParams();
  const [state, setState] = useState({ loading: true, clientKey: null, store: null, error: null });

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        // Default: using shop_profiles (recommended)
          const { data, error } = await supabase
            .from("accounts")
            .select("client_key, business_name, logo_path, store_slug")
            .or(`store_slug.eq.${slug},client_key.eq.${slug}`)
            .limit(1)
            .maybeSingle();

        // If you're truly using `accounts` instead, comment out the block above and use this:
        // const { data, error } = await supabase
        //   .from("accounts")
        //   .select("client_key, business_name, logo_path")
        //   .eq("store_slug", slug)
        //   .limit(1)
        //   .maybeSingle();

        if (error) throw error;
        if (!data) throw new Error("Store not found.");

        const store = {
          store_name: data.store_name || data.business_name || "My Store",
          logo_path: data.logo_path || null,
        };

        if (mounted) setState({ loading: false, clientKey: data.client_key, store, error: null });
      } catch (e) {
        if (mounted) setState({ loading: false, clientKey: null, store: null, error: e.message });
      }
    })();
    return () => { mounted = false; };
  }, [slug]);

  if (state.loading) return <div className="p-6 text-slate-600">Loading…</div>;
  if (state.error)   return <div className="p-6 text-rose-600">{state.error}</div>;

  return (
    <ShopLinkCatalog
      clientKey={state.clientKey}
      bucket="ritailink_users_media"
      demoItems={DEMO_ITEMS}          
      profileOverride={state.store} 
    />
  );
}
